<era-device-sync-status-retry-ui [allowRetry]="allowRetry$ | async"
                                 [syncType]="currentSyncType"
                                 (scheduleTaskEvent)="scheduleTask($event)">
</era-device-sync-status-retry-ui>